export default "__VITE_ASSET__CzWUM3gc__"